import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2 font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
          <span className="h-px w-6 bg-accent-500" />
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-accent-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-base" />
        </Link>
      )}
    </div>
  );
}